












































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import HasilPenunjangSvc from "@/services/HasilPenunjang";
import {
  buildKandidatPenunjang,
  buildKandidatPenunjangLain,
  JenisPenunjang,
  KandidatPenunjang,
  pilihanDariTeks,
  selaraskanPenunjang
} from "@/utils/klaimRehabMedik";

const LABEL: Record<string, string> = {
  lab: "Laboratorium",
  radiologi: "Pemeriksaan Radiologi",
  lain: "Penunjang Lain"
};

const JUDUL: Record<string, string> = {
  lab: "Hasil Laboratorium",
  radiologi: "Hasil Radiologi",
  lain: "Hasil Penunjang Lain"
};

@Component
export default class TabelPilihPenunjang extends Vue {
  @Prop({ default: null }) readonly value!: string | null;
  @Prop({ required: true, type: String }) readonly jenis!: JenisPenunjang;
  @Prop() readonly register!: string | number;
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;

  loading = false;
  gagal = false;
  kandidat: KandidatPenunjang[] = [];
  dipilih: string[] = [];

  private token = 0;

  private teksSendiri: string | null = null;

  headers = [
    { text: "Tgl Hasil", value: "tanggal", width: "12%" },
    { text: "Pemeriksaan", value: "nama", width: "22%" },
    { text: "Unit", value: "unit", width: "16%" },
    { text: "Hasil", value: "ringkas", sortable: false }
  ];

  get labelJenis(): string {
    return LABEL[this.jenis] || "Penunjang";
  }

  get judul(): string {
    return JUDUL[this.jenis] || "Hasil Penunjang";
  }

  get teksKosong(): string {
    return "Belum ada " + this.judul.toLowerCase() + " pada kunjungan ini.";
  }

  get terpilih(): KandidatPenunjang[] {
    return this.kandidat.filter(item => this.dipilih.indexOf(item.key) !== -1);
  }

  set terpilih(val: KandidatPenunjang[]) {
    const teks = selaraskanPenunjang(this.value, this.kandidat, val || []);

    this.dipilih = (val || []).map(item => item.key);
    this.teksSendiri = teks;

    this.$emit("input", teks);
  }

  @Watch("register", { immediate: true })
  onGantiRegister() {
    this.muat();
  }

  @Watch("value")
  onGantiNilai(val: string | null) {
    if (val === this.teksSendiri) return;

    this.turunkanPilihan();
  }

  private turunkanPilihan() {
    this.teksSendiri = this.value;
    this.dipilih = pilihanDariTeks(this.value, this.kandidat).map(
      item => item.key
    );
  }

  async muat() {
    const reg = this.register;
    const giliran = ++this.token;

    this.kandidat = [];
    this.dipilih = [];
    this.gagal = false;

    if (!reg) return;

    this.loading = true;

    try {
      const resp = await this.ambil(reg).catch(() => null);
      if (giliran !== this.token) return;

      this.gagal = resp === null;
      this.kandidat = this.bangun(resp);
      this.turunkanPilihan();
    } finally {
      if (giliran === this.token) this.loading = false;
    }
  }

  private ambil(reg: string | number): Promise<any> {
    if (this.jenis === "lab") {
      return HasilPenunjangSvc.getLabByRegister(reg, true);
    }

    if (this.jenis === "radiologi") {
      return HasilPenunjangSvc.getRadiologiByRegister(reg, true);
    }

    return HasilPenunjangSvc.getPenunjangLainByRegister(reg, true);
  }

  private bangun(resp: any): KandidatPenunjang[] {
    const baris = resp && Array.isArray(resp.data) ? resp.data : [];

    if (this.jenis === "lab") return buildKandidatPenunjang(baris, []);
    if (this.jenis === "radiologi") return buildKandidatPenunjang([], baris);

    return buildKandidatPenunjangLain(baris);
  }
}
